import React, { useState } from 'react';
import ConfirmationDialog from '../../Common/ConfirmationDialog';
import ReactToastify from '../../../customHook/useReactToastify';
import {
  useDeleteJobMutation,
  useLazyGetJobsByCompanyQuery,
} from '../../../features/apis/intergration';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBin6Line } from 'react-icons/ri';
import AddJob from '../AddJob';
import useCurrentUser from '../../../customHook/useCurrentUser';
export const RoleSidebar = ({
  jobs,
  selectedRole,
  setSelectedRole,
  top,
  setTop,
  resumes,
}) => {
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [jobToDelete, setJobToDelete] = useState({ id: '', title: '' });
  const [jobToEdit, setJobToEdit] = useState<any | null>(null);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteJob] = useDeleteJobMutation();
  const user = useCurrentUser();
  const [getJobsByCompany] = useLazyGetJobsByCompanyQuery();
  const handleDelete = async () => {
    try {
      await deleteJob(jobToDelete.id).unwrap();
      ReactToastify({
        success: true,
        message: 'Job deleted successfully',
      });
      await getJobsByCompany(user?.companyId).unwrap();
    } catch (error: any) {
      ReactToastify({
        success: false,
        message: error?.data?.message || 'Failed to delete job',
      });
    } finally {
      setConfirmDeleteOpen(false);
    }
  };

  return (
    <div className="w-full flex-shrink-0 flex flex-col gap-4 pr-6">
      <h1 className="text-xl">Roles</h1>
      <div className=" border-[#D4D4D4] border-[0.5px] p-2 rounded-lg">
        <div className="bg-gray-100 rounded-lg p-1 flex mb-4">
          {['Role List'].map((t) => (
            <button
              key={t}
              className={`flex-1 rounded-lg py-2 text-xs font-semibold transition-all ${
                t === 'Role List'
                  ? 'bg-[#6E3EF5] text-white'
                  : 'text-gray-500 bg-[#F6F3F3]'
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="flex flex-col gap-2.5 max-h-96 overflow-y-auto">
          {jobs && jobs.length > 0 ? (
            jobs.map((job) => (
              <div
                key={job._id}
                className={`p-4 rounded-xl cursor-pointer transition-all ${
                  selectedRole === job.jobTitle
                    ? 'bg-purple-50 border-purple-300 border-[1.5px] shadow-sm'
                    : 'bg-[#F9F6FF] border-[#D4D4D4] border-[0.5px]'
                }`}
              >
                <div className="flex justify-between items-start gap-2">
                  <span
                    className="text-xs text-gray-900 cursor-pointer"
                    onClick={() => setSelectedRole(job.jobTitle)}
                  >
                    {job.jobTitle}
                  </span>

                  <div className="flex gap-2 items-center">
                    <span className="text-[10px] px-2 py-0.5 rounded-lg bg-[#DBCEFF] text-[#272727] whitespace-nowrap">
                      {job.workMode || job.jobType}
                    </span>
                    <button
                      onClick={() => {
                        setJobToEdit(job);
                        setEditOpen(true);
                      }}
                      className="text-gray-400 hover:text-violet-600 transition"
                    >
                      <FiEdit2 size={14} />
                    </button>
                    <button
                      onClick={() => {
                        setJobToDelete({ id: job._id, title: job.jobTitle });
                        setConfirmDeleteOpen(true);
                      }}
                      className="text-gray-400 hover:text-red-500 transition"
                    >
                      <RiDeleteBin6Line size={14} />
                    </button>
                  </div>
                </div>

                <p className="text-[8px] text-gray-400 mt-1">
                  {job.skills?.slice(0, 60)}...
                </p>
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-10 gap-3 text-center">
              <svg
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* Briefcase body */}
                <rect
                  x="6"
                  y="18"
                  width="40"
                  height="28"
                  rx="5"
                  stroke="#D1C4F7"
                  strokeWidth="1.5"
                  fill="#F3EEFF"
                />
                {/* Briefcase handle */}
                <path
                  d="M18 18 L18 13 Q18 10 21 10 L31 10 Q34 10 34 13 L34 18"
                  stroke="#D1C4F7"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  fill="none"
                />
                {/* Center divider */}
                <line
                  x1="6"
                  y1="32"
                  x2="46"
                  y2="32"
                  stroke="#E9DEFF"
                  strokeWidth="1"
                />
                {/* Center clasp */}
                <rect
                  x="22"
                  y="28"
                  width="8"
                  height="8"
                  rx="2"
                  stroke="#C4A8F5"
                  strokeWidth="1.2"
                  fill="none"
                />
                {/* Plus badge circle */}
                <circle cx="40" cy="18" r="9" fill="#6E3EF5" />
                {/* Plus icon */}
                <line
                  x1="40"
                  y1="13"
                  x2="40"
                  y2="23"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <line
                  x1="35"
                  y1="18"
                  x2="45"
                  y2="18"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>

              <div>
                <p className="text-sm font-semibold text-gray-700">
                  No roles yet
                </p>
                <p className="text-xs text-gray-400 mt-0.5">
                  Add your first job to get started
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="bg-white border-[#D4D4D4] border-[0.5px] rounded-xl p-5">
        <div className="flex justify-between items-center mb-1">
          <span className="text-sm font-bold text-gray-900">Resume Bank</span>
          <span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-purple-100 text-purple-600">
            Remote
          </span>
        </div>
        <p className="text-xs text-gray-400 mb-3">
          {resumes?.length} candidates
        </p>
        <hr className="border-t-[0.5px] border-[#D4D4D4] mb-3" />
        <p className="text-xs font-semibold text-gray-700 mb-2">Bulk action</p>

        <div className="grid grid-cols-2 gap-2">
          {[3, 5, 20, 50, 70, 100].map((label) => (
            <button
              key={label}
              onClick={() => setTop(label)}
              className={`flex items-center justify-center gap-1.5 rounded-lg px-2 py-3 text-xs transition-all ${
                top === label
                  ? 'border border-purple-500 bg-purple-50 text-purple-700'
                  : ' border-[#D4D4D4] border-[0.5px] text-[#434343] bg-white'
              }`}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.66667 16.3333V14.0333M8.66667 3.3V1M16.3333 8.66667H14.0333M3.3 8.66667H1M14.0879 3.24552L12.4615 4.87186M4.87186 12.4615L3.24552 14.0879M3.24531 3.24568L4.87166 4.87203M12.4613 12.4617L14.0876 14.088"
                  stroke="#6E3EF5"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
              Top {label}
            </button>
          ))}
        </div>
      </div>

      {/* Edit modal — key forces remount when switching between jobs */}
      <AddJob
        key={(jobToEdit?._id as string) ?? 'new'}
        open={editOpen}
        onClose={() => {
          setEditOpen(false);
          setJobToEdit(null);
        }}
        job={jobToEdit}
      />

      <ConfirmationDialog
        open={confirmDeleteOpen}
        title={`Delete "${jobToDelete.title}"`}
        message="Are you sure you want to delete this job? This action cannot be undone."
        onConfirm={handleDelete}
        onCancel={() => setConfirmDeleteOpen(false)}
      />
    </div>
  );
};
